import { Module } from "vuex";
import { getters, UI_GETTERS } from "./getters";
import { actions, UI_ACTIONS } from "./actions";
import { mutations, UI_MUTATIONS } from "./mutations";
import { IUiState } from "./types";
import { IRootState } from "@/store/types";

export const state: IUiState = {
  isLoading: false,
  toasts: []
};

export namespace UI {
  export const ACTIONS = UI_ACTIONS;
  export const GETTERS = UI_GETTERS;
  export const MUTATIONS = UI_MUTATIONS;
  export const NAME_SPACE = "ui";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const ui: Module<IUiState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
